import {
  JbPopup
} from "./chunk.PO4WO7D2.js";
import {
  ae
} from "./chunk.Q25FCJRM.js";
import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  JBCookie
} from "./chunk.WXNWU2SV.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-newsletter-registration-form/jb-newsletter-registration-form.scss?inline
var jb_newsletter_registration_form_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.form-error,
.form-success {
  font-family: var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-regular-weight, 400);
}

.sticky h4, h4 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h4 {
  font-size: var(--theme-typo-h2-subtitle-mobile-fontsize, 1.625rem);
  line-height: var(--theme-typo-h2-subtitle-mobile-lineheight, 2.188rem);
}
@media (min-width: 1281px) {
  h4 {
    font-size: var(--theme-typo-h2-subtitle-desktop-fontsize, 1.938rem);
    line-height: var(--theme-typo-h2-subtitle-desktop-lineheight, 2.625rem);
  }
}

.sticky h4 {
  font-size: var(--theme-typo-p-mobile-fontsize, 1.063rem);
  line-height: var(--theme-typo-p-mobile-lineheight, 1.875rem);
}
@media (min-width: 1281px) {
  .sticky h4 {
    font-size: var(--theme-typo-p-desktop-fontsize, 1.188rem);
    line-height: var(--theme-typo-p-desktop-lineheight, 2.125rem);
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
.sticky {
  --_max-width: calc(100% - (2 * 6.68%));
  display: grid;
  grid-template-columns: [full-start] minmax(0, 1fr) [main-start] minmax(0, var(--theme-grid-max-width, var(--_max-width))) [main-end] minmax(0, 1fr) [full-end];
  margin-inline: auto;
}
@media (min-width: 600px) {
  .sticky {
    --_max-width: calc(100% - (2 * 8.35%));
  }
}
@media (min-width: 960px) {
  .sticky {
    --_max-width: calc(100% - (2 * 6.955%));
  }
}
@media (min-width: 1437px) {
  .sticky {
    --_max-width: 1437px;
  }
}

:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  transition: 0.5s all;
  width: 100%;
}

jb-form {
  --slotted-margin-block-start: 0;
}

.form-errors {
  display: grid;
  grid-column: 3/9;
}

.form-error,
.form-success {
  align-items: center;
  color: rgb(var(--rgb-primary, 20, 30, 85));
  display: flex;
  gap: 30px;
  padding: 30px;
  position: relative;
  transition: opacity 1s ease-in 0s, visibility 1s ease-in 0s;
}

.is-muted {
  opacity: var(--theme-opacity-70, 0.7);
}

.is-hidden {
  height: 0;
  opacity: 0;
  padding: 0;
  visibility: collapse;
}

@media (min-width: 960px) {
  .newsletter-registration-form:not(.sticky) .form-container {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
  }
  .newsletter-registration-form:not(.sticky) .content-container {
    grid-column: 1/11;
  }
  .newsletter-registration-form:not(.sticky) jb-form {
    grid-column: 2/10;
  }
  .newsletter-registration-form:not(.sticky) jb-form > jb-text-field {
    grid-column: 1/2;
  }
  .newsletter-registration-form:not(.sticky) jb-form > jb-button-primary {
    align-self: center;
    grid-column: 2/3;
    grid-row: 1;
    margin-top: 0;
  }
  .newsletter-registration-form:not(.sticky) jb-form > jb-checkbox {
    grid-column: 1/3;
  }
}
jb-form > * {
  grid-column: 1/3;
}

h4 {
  display: block;
  grid-column: 1/11;
  margin-bottom: var(--spacing-sm);
  position: relative;
  text-align: center;
}

jb-section-headline {
  grid-column: 1/11;
  margin-block-end: var(--spacing-2xs);
}
@media (min-width: 960px) {
  jb-section-headline {
    margin-block-end: var(--spacing-3xs);
  }
}

@media (min-width: 1281px) {
  .default h4 {
    font-family: VerlagSSm, Tahoma, sans-serif;
    font-size: 2.813rem;
    font-style: normal;
    font-weight: 200;
    line-height: 3.875rem;
  }
}
.sticky {
  bottom: 0;
  position: fixed;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  width: 100%;
}
.sticky .form-wrapper {
  grid-column: main;
}
@media (min-width: 1281px) {
  .sticky .form-wrapper {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }
}
.sticky .form-container {
  --_text-translate: 13px;
  background-color: #141e55;
  box-shadow: 0, 0, 0, 0.2 20px -20px 68px;
  column-gap: var(--spacing-l);
  padding: var(--spacing-s);
  position: relative;
  transition: padding-block-end 0.3s ease-in-out;
  --form-flex-gap: var(--spacing-sm);
}
@media (min-width: 1281px) {
  .sticky .form-container {
    display: grid;
    grid-column: 2/12;
    grid-template-columns: subgrid;
    padding: var(--spacing-l) var(--spacing-xl);
    row-gap: var(--spacing-sm);
    --form-flex-gap: var(--spacing-sm);
  }
  .sticky .form-container .content-container {
    grid-column: 1/5;
    padding-inline-start: calc(var(--spacing-xl) - var(--spacing-s));
  }
  .sticky .form-container jb-form {
    grid-column: 5/10;
    transform: translateY(calc(-1 * var(--_text-translate)));
  }
  .sticky .form-container jb-button-primary {
    width: min-content;
  }
}
.sticky .form-errors {
  display: grid;
  grid-column: 5/10;
}
.sticky jb-section-headline {
  --headline-text-align: left;
  --host-color: #fff;
  margin-block-end: var(--spacing-3xs);
}
.sticky jb-checkbox {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.sticky h4 {
  color: #fff;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  text-align: left;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.sticky.show {
  transform: translateY(var(--_scrolloutheight));
}
.sticky.expanded {
  transform: translateY(0);
}
.sticky.expanded .form-container {
  padding-block-end: calc(var(--spacing-l) - var(--_text-translate));
}
.sticky.expanded h4 {
  max-height: 50vh;
  opacity: 1;
}
.sticky.expanded jb-checkbox {
  opacity: 1;
}
.sticky jb-close-icon {
  right: var(--spacing-s);
  top: var(--spacing-s);
}
@media (min-width: 1281px) {
  .sticky jb-close-icon {
    right: var(--spacing-xl);
    top: var(--spacing-l);
  }
}

.popup {
  display: none;
}
.popup .form-container {
  box-shadow: 20px -20px 68px rgba(0, 0, 0, 0.2);
  column-gap: var(--spacing-l);
  padding-block: calc(var(--spacing-sm) + 26px + var(--spacing-xs)) var(--spacing-2xl);
  padding-inline: var(--spacing-s);
  --form-flex-gap: var(--spacing-sm);
}
@media (min-width: 960px) {
  .popup .form-container {
    --form-flex-gap: 20px;
  }
}
.popup jb-close-icon {
  right: var(--spacing-s);
  top: var(--spacing-sm);
}
.popup h4 {
  color: #fff;
}
@media (min-width: 960px) {
  .popup jb-section-headline {
    margin-bottom: var(--spacing-s);
  }
  .popup .content-container {
    grid-column: 2/10;
  }
  .popup .form-container {
    padding-block: var(--spacing-2xl);
    padding-inline: 0;
  }
}
@media (min-width: 1281px) {
  .popup {
    margin-inline: -20px;
  }
  .popup jb-close-icon {
    right: var(--spacing-l);
    top: var(--spacing-2xl);
  }
}

.popup,
.sticky {
  z-index: 111;
  --host-color: #fff;
}
.popup jb-section-headline,
.sticky jb-section-headline {
  margin-block-end: var(--spacing-3xs);
}
.popup jb-text-field,
.sticky jb-text-field {
  --rgb-primary: 255, 255, 255;
  --background-color: transparent;
  --border-opacity: 0.7;
}
.popup jb-checkbox,
.sticky jb-checkbox {
  --rgb-primary: 255, 255, 255;
  --border-opacity: 0.7;
  --text-opacity: 1;
}
.popup jb-close-icon,
.sticky jb-close-icon {
  --rgb-primary: 255, 255, 255;
  --icon-size: 26px;
  position: absolute;
}
@media (min-width: 1281px) {
  .popup jb-close-icon,
  .sticky jb-close-icon {
    --icon-size: 30px;
    z-index: 1;
  }
}
.popup .form-container,
.sticky .form-container {
  background-color: #141e55;
  position: relative;
}
.popup jb-richtext,
.sticky jb-richtext {
  color: white;
  --rgb-primary: 255, 255, 255;
}

@media print {
  :host {
    display: none;
  }
}`;

// src/components/jb-newsletter-registration-form/jb-newsletter-registration-form.ts
var stickyCookieName = "jbNlReg";
var stickyWaitTime = 20 * 1e3;
var JbNewsletterRegistrationForm = class extends Spaceable(h) {
  constructor() {
    super(...arguments);
    this.forceInstantly = false;
    this.formAction = "";
    this.headline = "";
    this.subline = "";
    this.successText = "";
    this.type = "default";
    this._formOpenTrackedSticky = false;
    this._formSent = false;
    this._formValid = false;
  }
  firstUpdated() {
    if (this.type === "sticky") {
      this._inputField.addEventListener("focusin", () => {
        this._expandStickyContainer();
      });
      setTimeout(() => {
        const newsletterRegistrationCookieValue = JBCookie.getCookie(stickyCookieName);
        if (newsletterRegistrationCookieValue) {
          return;
        }
        const agreementText = this.renderRoot.querySelector("jb-richtext.agreementText");
        const checkbox = this.renderRoot.querySelector("jb-checkbox");
        const button = this.renderRoot.querySelector("jb-button-primary");
        let paddingAdjustment = window.matchMedia("(min-width: 367px)").matches ? 38 : 58;
        paddingAdjustment = window.matchMedia("(min-width: 1281px)").matches ? 61 : paddingAdjustment;
        this._unexpandListener = this._unexpand.bind(this);
        document.addEventListener("click", this._unexpandListener);
        this.style.setProperty(
          "--_scrolloutheight",
          `${(checkbox ? checkbox.offsetHeight : 0) + (agreementText ? agreementText.offsetHeight : 0) + button.offsetHeight + paddingAdjustment}px`
        );
        this._formWrapper.classList.add("show");
      }, stickyWaitTime);
    }
    this.addEventListener("jb-tracking", (e2) => {
      const customEvent = e2;
      if (customEvent.detail?.event === "ce_form") {
        customEvent.detail.component_name = this.type === "sticky" ? "newsletter-registration-form" : "article-tool-bar";
        customEvent.detail.form_subject = "newsletter";
      }
      if (customEvent.detail?.event === "ce_form" && customEvent.detail?.form_step_name === "form open") {
        customEvent.stopPropagation();
        this._formOpenEvent = customEvent;
      }
    });
  }
  static open() {
    const newsletterRegistrationNode = document.querySelector("jb-newsletter-registration-form");
    if (!newsletterRegistrationNode) {
      return;
    }
    const newsletterRegistrationWrapper = newsletterRegistrationNode.shadowRoot?.firstElementChild;
    newsletterRegistrationWrapper.style.display = "block";
    const clone = newsletterRegistrationNode.cloneNode(true);
    newsletterRegistrationNode.parentNode.appendChild(clone);
    new JbPopup().init({
      props: { animates: true },
      childNodes: [newsletterRegistrationNode]
    }).stack();
    document.body.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_form",
          event_version: "v2",
          component_name: "article-tool-bar",
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: "newsletter registration",
          form_type: "newsletter"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _captureTracking(evt) {
    evt.stopPropagation();
    if (this.type === "default") {
      this._trackFormOpen("newsletter-registration-form");
    }
  }
  _expandStickyContainer() {
    this._formWrapper.classList.add("expanded");
    if (!this._formOpenTrackedSticky) {
      this._trackFormOpen("sticky-newsletter");
      this._formOpenTrackedSticky = true;
    }
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 10, grid: true };
  }
  _handleCloseIconClick() {
    if (this.type === "sticky") {
      this._formWrapper.classList.remove("show");
      this._formWrapper.classList.remove("expanded");
      JBCookie.setCookie(stickyCookieName, "1", 182);
      document.removeEventListener("click", this._unexpandListener);
    }
    if (this.type === "popup") {
      document.querySelector("jb-popup")?.unstack();
    }
  }
  _submit() {
    const form = this._formWrapper.querySelector("jb-form");
    const slottedInputs = form.querySelectorAll("jb-text-field, jb-checkbox");
    const additionalInputs = form.shadowRoot?.querySelectorAll("input");
    const formData = {};
    let isValid = true;
    Array.from([...slottedInputs, ...additionalInputs || []]).forEach((element) => {
      try {
        if (element.validate) {
          isValid = element.validate() && isValid;
        }
        const name = element.getAttribute("name");
        formData[name] = element.value;
        if (element.tagName === "JB-CHECKBOX") {
          formData[name] = element.checkbox?.checked;
        } else {
          formData[name] = element.value;
        }
      } catch (err) {
      }
    });
    this._formValid = isValid;
    if (!isValid) {
      return;
    }
    if (this.agreementFieldName in formData) {
      formData.first_party_data_processing = true;
    }
    formData.source = this.type;
    form.classList.add("is-muted");
    if (this.submissionMode === "fetch") {
      fetch(this.formAction, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        redirect: "follow",
        body: JSON.stringify(formData)
      }).then((response) => {
        if (!response.ok) {
          this._formSent = true;
          this.updateComplete.then(() => {
            this._formError.classList.toggle("is-hidden");
            form.classList.remove("is-muted");
          });
        }
        return response.json();
      }).then((data) => {
        if (data.success === true) {
          this._formSent = true;
          this.updateComplete.then(() => {
            this._formSuccess.classList.toggle("is-hidden");
            form.classList.toggle("is-hidden");
          });
        }
      }).then(() => {
        setTimeout(() => {
          this._handleCloseIconClick();
        }, 3e3);
      });
    }
  }
  _trackFormOpen(componentName) {
    document.body.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_form",
          event_version: "v2",
          component_name: componentName,
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: "newsletter registration",
          form_type: "newsletter"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _unexpand(evt) {
    if (evt.target.nodeName === "JB-NEWSLETTER-REGISTRATION-FORM" || !this._formWrapper.classList.contains("expanded"))
      return;
    this._formWrapper.classList.remove("expanded");
  }
  render() {
    return ke`
      <div class="newsletter-registration-form ${this.type}">
        <div class="form-wrapper">
          <div class="form-container">
            <div class="content-container">
              ${this.headline ? ke`<jb-section-headline .headline=${this.headline}></jb-section-headline>` : D}
              ${this.subline ? ke`<h4>${this.subline}</h4>` : D}
            </div>
            ${this.type === "sticky" || this.type === "popup" ? ke`<jb-close-icon @click=${this._handleCloseIconClick}></jb-close-icon>` : D}
            ${!this._formSent ? ke`<jb-form
                  novalidate
                  .action=${this.formAction}
                  method="post"
                  .displayGrid=${false}
                  .additionalData=${this.formAdditionalData}
                  trackingSubject="newsletter-registration-form"
                  @jb-form:submit=${(e2) => {
      if (this.formAction !== "") {
        e2.detail.preventDefault();
      }
    }}
                  @jb-tracking=${this._captureTracking}
                >
                  <jb-text-field
                    .emailErrorText=${this.emailFieldData.emailErrorText}
                    .type=${this.emailFieldData.type}
                    name=${this.emailFieldData.name}
                    ?isWhite=${this.type === "sticky" || this.type === "popup"}
                    .placeholder=${this.emailFieldData.placeholder}
                    .label=${this.emailFieldData.label}
                    .requiredText=${this.emailFieldData.emailErrorText}
                  >
                  </jb-text-field>
                  ${ke`
                    <jb-checkbox
                      .afterCheckboxText=${this.afterCheckboxText}
                      .beforeCheckboxText=${this.beforeCheckboxText}
                      .label=${this.agreement}
                      ?isWhite=${this.type === "sticky" || this.type === "popup"}
                      name=${this.agreementFieldName}
                      .required=${this.agreementRequiredText ? true : D}
                      .requiredText=${this.agreementRequiredText}
                      value="accepted"
                    >
                    </jb-checkbox>
                  `}
                  <jb-button-primary
                    name="submit"
                    formName="Newsletter Registration Form"
                    componentName="newsletter-registration-form"
                    @click=${this._submit}
                    ?inverted=${this.type !== "default"}
                    >${this.subscribeBtn.text}</jb-button-primary
                  >
                </jb-form>` : ke`<div class="form-errors">
                  <div class="form-error is-hidden">
                    <jb-richtext>${ae(this.errorText)}</jb-richtext>
                  </div>
                  <div class="form-success is-hidden">
                    <jb-checkmark-icon></jb-checkmark-icon><jb-richtext>${ae(this.successText)}</jb-richtext>
                  </div>
                </div>`}
          </div>
        </div>
      </div>
    `;
  }
};
JbNewsletterRegistrationForm.styles = r(jb_newsletter_registration_form_default);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "afterCheckboxText", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "agreement", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "agreementFieldName", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "agreementRequiredText", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "beforeCheckboxText", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "emailFieldData", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "errorText", 2);
__decorateClass([
  n({ type: Boolean })
], JbNewsletterRegistrationForm.prototype, "forceInstantly", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "formAdditionalData", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "headline", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "subline", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "submissionMode", 2);
__decorateClass([
  n({ type: Object })
], JbNewsletterRegistrationForm.prototype, "subscribeBtn", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "successText", 2);
__decorateClass([
  n()
], JbNewsletterRegistrationForm.prototype, "type", 2);
__decorateClass([
  e(".form-error")
], JbNewsletterRegistrationForm.prototype, "_formError", 2);
__decorateClass([
  r2()
], JbNewsletterRegistrationForm.prototype, "_formSent", 2);
__decorateClass([
  e(".form-success")
], JbNewsletterRegistrationForm.prototype, "_formSuccess", 2);
__decorateClass([
  e(".newsletter-registration-form")
], JbNewsletterRegistrationForm.prototype, "_formWrapper", 2);
__decorateClass([
  e("jb-text-field")
], JbNewsletterRegistrationForm.prototype, "_inputField", 2);
JbNewsletterRegistrationForm = __decorateClass([
  customElement("jb-newsletter-registration-form")
], JbNewsletterRegistrationForm);
document.addEventListener("jbNewsletterOverlayPopupOpen", JbNewsletterRegistrationForm.open);

export {
  JbNewsletterRegistrationForm
};
